import { useMutation } from '@tanstack/react-query';
import { MutationConfig, queryClient } from '@/libs/react-query';
import axios from '@/libs/axios';

interface Request {
  code: string;
}

interface Response {
  msg: string;
  status: number;
}

const request = async (data: Partial<Request>): Promise<Response> => {
  return axios.post('bindotp', data);
};

type UseOptions = {
  config?: MutationConfig<typeof request>;
};
export const useBindOtp = ({ config }: UseOptions) => {
  return useMutation({
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['user-info'] });
    },
    mutationFn: request,
    ...config,
  });
};
